export default {
  tryAgain: "Try again",
  goHome: "Go home",
  loading: "Loading…",
  send: "Send",
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  optional: "Optional",
  edit: "Edit",
  back: "Back",
  refresh: "Refresh",
  confirm: "Confirm",
  close: "Close",
  add: "Add",
  copy: "Copy",
  copySerial: "Copy serial",
  copied: "Copied!",
  clickToCopy: "Click to copy",
  clickToCopyValue: "Copy {{value}}",
  copyFailed: "Could not copy to clipboard",
  search: "Search",
  clearSearch: "Clear search",
  quickSearch: {
    title: "Quick search",
    placeholder: "Go to a page…",
    empty: "No matching pages",
    hint: "↑↓ to navigate · Enter to open · Esc to close",
  },
  inactive: "Inactive",
  user: "User",
  privacyPolicy: "Privacy Policy",
  cookiePolicy: "Cookie Policy",
  cookiePreferences: "Cookie preferences",
  privacyAndCookies: "Privacy and cookies",
  privacyPolicyOpening: "Opening privacy policy…",
  backToDashboard: "Back to dashboard",
  backToLogin: "Back to login",
  copyright: "© {{year}} Flitrip. All rights reserved.",
  language: {
    label: "Language",
  },
  greeting: {
    morning: "Good morning",
    afternoon: "Good afternoon",
    evening: "Good evening",
  },
  errorOccurred: "An error occurred",
  somethingWentWrong: "Something went wrong. Please try again later.",
  appCrashTitle: "Something went wrong",
  appCrashMessage:
    "Try again to remount the screen without leaving the app. If it keeps failing, use your browser refresh or go home.",
  relative: {
    justNow: "Just now",
    minutesAgo: "{{count}}m ago",
    hoursAgo: "{{count}}h ago",
    daysAgo: "{{count}}d ago",
  },
  chat: {
    dayToday: "Today",
    dayYesterday: "Yesterday",
  },
  fileSize: {
    bytes: "{{count}} B",
    kb: "{{size}} KB",
    mb: "{{size}} MB",
  },
  unsavedChanges: {
    navigationTitle: "Unsaved changes",
    navigationMessage: "Save or revert your changes before leaving this page.",
  },
  sectionModified: "Modified",
  saveBar: {
    unsaved: "Unsaved changes",
    allSaved: "Everything saved",
    save: "Save changes",
    saveDraft: "Save draft",
    revert: "Revert changes",
    revertConfirmTitle: "Discard unsaved changes?",
    revertConfirmMessage: "Your edits will be lost. This cannot be undone.",
    revertConfirm: "Discard changes",
  },
  addressAutocomplete: {
    loading: "Searching addresses…",
    error: "Could not load address suggestions.",
    noStreetResults:
      "No street addresses found. Keep typing or pick a full address from the list.",
  },
  addressSearch: {
    label: "Address",
    placeholder: "Start typing to search for an address…",
    editDetails: "Edit address details",
    detailFieldsError: "Check the address details below.",
    fieldRequired: "This field is required.",
  },
  addressValidation: {
    checking: "Checking address…",
    valid: "Address is valid",
    invalid:
      "This address could not be located. Please check the details or pick another address.",
    incomplete: "Complete all address fields to validate the location.",
    saveConfirmTitle: "Invalid address",
    saveConfirmButton: "Save anyway",
    saveWarningActivity:
      "This address is invalid. Customers may not see this activity in the app because it requires a geocoded location.",
    saveWarningHouse:
      "This address is invalid and may not be geocoded correctly. Location services for this structure may not work.",
  },
  editableLocation: {
    noCoordinatesWarning:
      "Pick an address from the list, type a recognizable address, or click the map to set the location.",
    mapHint: "Drag the marker or click the map to adjust the location.",
    mapUnavailable: "Map preview is unavailable (map not configured).",
    mapAriaLabel: "Editable location map",
  },
  map: {
    expand: "Expand",
    expandedTitle: "Map",
    zoomHintCtrl: "Use Ctrl + scroll to zoom the map",
    zoomHintCmd: "Use ⌘ + scroll to zoom the map",
    panHintTouch: "Use two fingers to move the map",
  },
  environmentBanner: {
    message:
      "You are in the {{environment}} environment. This is not production — data and payments are for testing only.",
    messageShort: "You're in {{environment}}",
    productionMessage:
      "You are in production. You are using live data and real payment processing — proceed with caution.",
    productionMessageShort: "You're in production",
    envNames: {
      development: "development",
      staging: "staging",
    },
    shortEnvNames: {
      development: "development",
      staging: "staging",
    },
  },
  region: {
    label: "Payment region",
    empty: "No regions available",
    filterAll: "All regions",
    filterLabel: "Region",
    colCode: "Region",
    unknown: "—",
    names: {
      IT: "Italy",
      ES: "Spain",
    },
  },
  table: {
    paginationSummary: "Showing {{start}}-{{end}} of {{total}}",
    rowsPerPage: "Rows per page",
    previousPage: "Previous",
    nextPage: "Next",
    pageOf: "Page {{page}} of {{totalPages}}",
    resizeColumn: "Resize column",
    resizeColumnFor: "Resize {{column}} column",
    preferencesOpen: "Preferences",
    preferencesTitle: "Table preferences",
    preferencesDescription:
      "Choose how many rows to show and which columns to display.",
    preferencesPageSize: "Rows per page",
    preferencesColumns: "Columns",
    preferencesColumnsHint: "Drag to reorder. Uncheck to hide a column.",
    preferencesConfirm: "Confirm",
    preferencesCancel: "Cancel",
    preferencesReset: "Reset to default",
    reorderColumn: "Reorder column",
    selectRow: "Select row",
    selectionColumn: "Selection",
    selectionHint: "Use the checkboxes on the left to select rows.",
    selectedCount: "{{count}} selected",
    selectAllOnPage: "Select all on this page",
    clearSelection: "Clear selection",
  },
} as const;
